<template>
<div style="width:100%;min-height:900px;height:100%;background-color:#d0d0d0;padding: 10px 0 0 0;">
    <div class="sendMail">
        <el-form :model="ruleForm" ref="ruleForm" :rules="rules" :inline="true" label-width="100px" class="demo-dynamic">
            <el-form-item prop="email" label="邮箱">
                <el-input v-model="ruleForm.email"></el-input>
            </el-form-item>
            <el-form-item label="获取码" prop="hqm">
                <el-input v-model="ruleForm.hqm"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                <el-button @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
        </el-form>
        <div style="margin: 10px auto;width:1000px;background;"> 
            <div class="d1" style="width:500px;height:200px;display:inline-block;float:left;text-align:left;">
                <p>公告列表</p>
                <!-- <el-input type="textarea" :rows="6" style="width:400px" v-for="(item,i) in anntList" :key="i" :readonly="true" :value="item.content"></el-input> -->
                <!-- <div style="width:400px;height:120px;margin-top:10px;border:1px solid #000" v-for="(item,i) in anntList" :key="i" >
                   
                </div> -->
                <el-card class="box-card" :body-style="{padding:'10px 15px'}" shadow="hover" v-for="(item,i) in anntList" :key="i">
                    <div v-html="item.content"></div>
                    <el-button @click="showHqm(item.hqm)" v-if="item.hqm != null && item.hqm != ''">获取</el-button>
                </el-card>
            </div>
            <div class="d2" style="width:500px;height:200px;display:inline-block;float:left;text-align:left">
                <p>最近更新</p>
                <el-card class="box-card" :body-style="{padding:'10px 15px'}" shadow="hover" v-for="(item,i) in renewList" :key="i">
                    <div v-html="item.content"></div>
                    <el-button @click="showHqm(item.hqm)" v-if="item.hqm != null && item.hqm != ''">获取</el-button>
                </el-card>
            </div>
        </div>
        <!-- <input type="textarea" style="width:500px"> -->
    </div>
</div>
</template>

<script>
    export default {
        name: "sendMail",
        data() {
            return {
                ruleForm: {
                    email: '',
                    hqm:'',
                },
                rules: {
                    email: [
                        { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                        { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                    ],
                    hqm: [
                        { required: true, message: '请输入获取码', trigger: 'blur' },
                        // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                    ],
                },
                textarea:'',
                anntList:'',//公告列表
                renewList:'',//最新更新内容列表
            };
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                if (valid) {
                    let _this = this;
                    this.$axios({
                        method: 'post',
                        url: '/clientController/sendEmail.do',
                        data: {
                            'email': (_this.ruleForm.email + '').trim(),
                            'hqm': (_this.ruleForm.hqm + '').trim(),
                        },
                    })
                    .then(res => {  //res是返回结果
                        // console.log(res)
                        this.$message({//消息提示框
                            message: '发送成功',
                            type: 'success',
                            showClose: true,//是否有关闭按钮
                            duration: 1000 //持续时间
                        });
                    })
                } else {
                    console.error('error submit!!');
                    return false;
                }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            setSSid(SSid) {
                this.ruleForm.hqm = SSid;
            },
            getList(){
                let _this = this;
                this.$axios.post('/ssBaseController/getAnnouncementAndRenewList.do')
                .then(res => {  //res是返回结果
                    // console.log(res)
                    _this.anntList = res.anntList;
                    _this.renewList = res.renewList;
                })
            },
            showHqm(data){
                // console.log(data);
                this.ruleForm.hqm = data;
            }
        },
        created:function () {//组件实例化之后执行，页面尚未显示
            this.getList();
        },
    }
    
</script>

<style scoped>
/* *{
  padding: 0;
  margin: 0;
} */
.sendMail{
  display:inline-block;
  height:100%;
  width:100%;
  max-width: 1200px;
  min-width: 1000px;
  text-align: center;
  /* display:flex; */
  /* justify-content: center; */
  /* align-items: center; */
  /* flex-direction:column; */
  background-color:#d0d0d0;
}
.d1 .box-card {
    width: 400px;
    /* height:120px; */
    margin:10px auto 10px;
    max-height: 145px;
    /* min-height: 145px; */
    overflow: auto;
}

.d2 .box-card {
    width: 400px;
    /* height:120px; */
    margin:10px auto 10px;
    max-height: 145px;
    min-height: 145px;
    overflow: auto;
}
</style>